import { ReactNode } from "react";
import { SlideAction, ViewMode } from "./enums";

export interface ColumnData {
  title: string;
  mainComponent: ReactNode;
  headerComponent?: ReactNode;
  showHeader?: boolean;
  showBackButton?: boolean;
  backButtonTransition?: SlideAction;
  onBackButtonPress?: () => void;
  /** When true, the column content won't be wrapped in a ScrollView (useful for components with internal scroll) */
  disableScroll?: boolean;
}

// Context for passing click handlers and navigation to column content
export interface SlideLayoutContextType {
  /** Which column this component is rendered in */
  column: 'left' | 'right';
  /**
   * Current view mode (SINGLE or DUAL)
   */
  currentViewMode: ViewMode;
  /**
   * Execute a slide action and await for animation to complete
   * @param action - The slide action to execute (SINGLE, DUAL, NEXT, PREV, or default for fade in)
   * @returns Promise that resolves when the animation completes
   */
  onSlideChange: (action: SlideAction) => Promise<void>;/**
   * Set a custom title for a column by its id. Pass undefined to reset to default.
   * WARNING: Call this method only after the column has been rendered to avoid title reset on re-render.
   * @param title - New title for the column
   */
  setColumnTitle: (title: string | undefined) => void;
  /**
   * Set a full-column overlay for this column (e.g. unsaved changes sheet).
   * Pass null to clear.
   */
  setColumnOverlay: (overlay: ReactNode | null) => void;
}

export interface SlideLayoutProps {
  leftColumn: ColumnData;
  rightColumn?: ColumnData;
  viewMode?: ViewMode;
  onViewModeChange?: (mode: ViewMode) => void;
  /** When this key changes while in DUAL mode, triggers a slide-in animation for the left column */
  transitionKey?: string;
}